<div class="workorder-view-container">
  <div class="trip-detail-popup-right">
    <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()" />
  </div>
  <div class="driver-view">
    <div class="heading">
      <h3>View Work Order</h3>
    </div>
    <mat-divider></mat-divider>
    
    <div *ngIf="!enabledetails" class="row m-0 mt-3">
      <div class="col-md-12">
        <div class="row mtb mr-0 ml-0">
          <div class="col-sm-6">
            <div class="head">Customer Mobile No</div>
            <div class="dec">{{ user_id?.mobile || work_order?.userInfo?.mobile }}</div>
          </div>
          <div class="col-sm-6">
            <div class="head">Customer Name</div>
            <div class="dec">{{ user_id?.username || work_order?.userInfo?.username }}</div>
          </div>
        </div>
        
        <div class="locations mt-4 mb-4">
          <div class="row mb mr-0 ml-0">
            <div class="col-md-12 head" style="font-size: 20px; font-weight: 600;">Pickup and Dropoff Location:</div>
          </div>
          <div class="payment-container" style="padding-left: 15px;">
            <div class="location-payment">
              <div class="places">
                <div class="place-row">
                  <mat-icon>near_me</mat-icon>
                  <div class="place-text">
                    <h4>{{ work_order.fromLocation?.from_city_name || work_order.from_area_name || 'Pickup' }}</h4>
                    <div class="dec" style="font-size: 14px; margin-top: 2px;">{{ work_order.from_complete_address }}</div>
                    <div class="result">Contact Details: {{ work_order.pickup_name ? work_order.pickup_name + ' - ' : '' }}{{ work_order.pickup_contact || '-' }}</div>
                  </div>
                </div>
                <div class="place-row">
                  <mat-icon>location_on</mat-icon>
                  <div class="place-text">
                    <h4>{{ work_order.toLocation?.to_city_name || work_order.to_area_name || 'Dropoff' }}</h4>
                    <div class="dec" style="font-size: 14px; margin-top: 2px;">{{ work_order.to_complete_address }}</div>
                    <div class="result">Contact Details: {{ work_order.dropoff_name ? work_order.dropoff_name + ' - ' : '' }}{{ work_order.dropoff_contact || '-' }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb mr-0 ml-0 mt-4">
          <div class="col-sm-4">
            <div class="head">Pickup Date</div>
            <div class="dec">
              <mat-icon style="margin-right: 10px; font-size: 20px; height: 20px; width: 20px;">calendar_today</mat-icon>
              {{ work_order.pickup_date | date }}
            </div>
          </div>
          <div class="col-sm-4">
            <div class="head">Truck Category</div>
            <div class="dec">{{ work_order.truck_category_name }}</div>
          </div>
          <div class="col-sm-4">
            <div class="head">Wo</div>
            <div class="dec">{{ work_order.total_tons }} Tons</div>
          </div>
        </div>

        <div class="row mb mr-0 ml-0 mt-3">
          <div class="col-sm-4">
            <div class="head">Updated Date</div>
            <div class="dec">
              <mat-icon style="margin-right: 10px; font-size: 20px; height: 20px; width: 20px;">calendar_today</mat-icon>
              {{ work_order.updated_date ? (work_order.updated_date | date : "dd-MM-yyyy, hh:mm a") : "-" }}
            </div>
          </div>
        </div>

        <div class="row mb mr-0 ml-0">
          <div class="col-sm-4">
            <div class="head">Price/ Ton</div>
            <div class="dec">₹ {{ work_order.price_per_ton | number : "1.2-2" }}</div>
          </div>
          <div class="col-sm-4">
            <div class="head">Load Category</div>
            <div class="dec">{{ work_order.load_type }}</div>
          </div>
          <div class="col-sm-4">
            <div class="head">Material Type</div>
            <div class="dec">{{ work_order.material_type }}</div>
          </div>
        </div>

        <div class="heading mt-4">
          <h3>Wo Summary</h3>
        </div>
        <mat-divider></mat-divider>

        <div class="row mtb mr-0 ml-0">
          <div class="col-sm-3">
            <div class="head">WO QTY</div>
            <div class="dec">{{ work_order.total_tons | number : "1.2-2" }}</div>
          </div>
          <div class="col-sm-3">
            <div class="head">Issued WO</div>
            <div class="dec">
              {{ work_order.totalTruckWeight < work_order.total_tons 
                  ? (work_order.totalTruckWeight | number : '1.2-2') 
                  : (work_order.total_tons | number : '1.2-2') 
              }}
            </div>
          </div>
          <div class="col-sm-3">
            <div class="head">Available WO</div>
            <div class="dec">
              {{ work_order.total_tons - work_order.totalLoadingPoint | number : "1.2-2" }}
            </div>
          </div>
          <div class="col-sm-3">
            <div class="head">Used DO</div>
            <div class="dec">{{ work_order.totalLoadingPoint | number : "1.2-2" }}</div>
          </div>
        </div>

        <div class="heading mt-4">
          <h3>Billing & Pickup/Dropoff Details</h3>
        </div>
        <mat-divider></mat-divider>

        <div class="row mtb mr-0 ml-0">
          <div class="col-sm-6">
            <div class="head">Billing Address</div>
            <div class="dec mt-2">{{ work_order.billing_address?.username }}</div>
            <div class="dec">{{ work_order.billing_address?.address_line }}</div>
            <div class="dec">{{ work_order.billing_address?.city }}, {{ work_order.billing_address?.state }} - {{ work_order.billing_address?.pincode }}</div>
            <div class="dec">GST: {{ work_order.billing_address?.gst }}</div>
          </div>
          <div class="col-sm-6">
            <div class="row mb mr-0 ml-0">
              <div class="col-sm-6">
                <div class="head">Pickup Contact</div>
                <div class="dec mt-2">{{ work_order.pickup_name }}</div>
                <div class="dec">{{ work_order.pickup_contact }}</div>
              </div>
              <div class="col-sm-6">
                <div class="head">Dropoff Contact</div>
                <div class="dec mt-2">{{ work_order.dropoff_name }}</div>
                <div class="dec">{{ work_order.dropoff_contact }}</div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="doDetails">
          <div class="heading mt-4">
            <h3>Do Details</h3>
          </div>
          <mat-divider></mat-divider>
          
          <div *ngFor="let doDetails of work_order.doInfo">
            <div class="row mb mt-3 mr-0 ml-0">
              <div class="col-sm-3">
                <div class="head">DO ID</div>
                <div class="dec">
                  {{ doDetails.do_id }}
                  <a class="driver-view-link ml-2" (click)="editTruckOwner(doDetails)" style="text-decoration: underline; color: red; font-size: 14px; cursor: pointer;">Edit</a>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="head">DO Date</div>
                <div class="dec">{{ doDetails.createdAt | date }}</div>
              </div>
              <div class="col-sm-3">
                <div class="head">Issued Qty</div>
                <div class="dec">{{ doDetails.do_quantity }}</div>
              </div>
              <div class="col-sm-3">
                <div class="head">Available Qty in DO</div>
                <div class="dec">{{ doDetails.remaining_tons }}</div>
              </div>
            </div>
            
            <div class="row mb mr-0 ml-0">
              <div class="col-sm-3">
                <div class="head">Transporter Name</div>
                <div class="dec">{{ doDetails.truckowner_id?.username }}</div>
              </div>
              <div class="col-sm-3">
                <div class="head">Mobile No</div>
                <div class="dec">{{ doDetails.truckowner_id?.mobile }}</div>
              </div>
              <div class="col-sm-3">
                <div class="head">Transporter ID</div>
                <div class="dec">{{ doDetails.truckowner_id?.truckowner_id }}</div>
              </div>
              <div class="col-sm-3">
                <div class="head">Trips Assigned</div>
                <div class="dec">{{ doDetails?.tripAssignedCount }}</div>
              </div>
            </div>
            <mat-divider></mat-divider>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
